import Notifications from "@/pages/Notifications";
import Assistant from "@/pages/Assistant";
import Analytics from "@/pages/Analytics";
import AnalyticsBuyingPatterns from "@/pages/AnalyticsBuyingPatterns";
import AnalyticsBuyingPatternsList from "@/pages/AnalyticsBuyingPatternsList";
import AnalyticsDemandForecast from "@/pages/AnalyticsDemandForecast";
import AnalyticsDemandForecastList from "@/pages/AnalyticsDemandForecastList";
import AnalyticsRestockList from "@/pages/AnalyticsRestockList";
import AnalyticsRestockPlanner from "@/pages/AnalyticsRestockPlanner";
import AnalyticsTopPerformers from "@/pages/AnalyticsTopPerformers";
import AnalyticsTopPerformersList from "@/pages/AnalyticsTopPerformersList";
import AnalyticsTurnover from "@/pages/AnalyticsTurnover";
import AnalyticsTurnoverList from "@/pages/AnalyticsTurnoverList";
import Support from "@/pages/Support";
import Reports from "@/pages/Reports";
import Tutorials from "@/pages/Tutorials";

export const ENGAGEMENT_WORKSPACE_ROUTES = [
  { path: "/tutorials", element: Tutorials },
  { path: "/support", element: Support },
  { path: "/notifications", element: Notifications, permission: "notifications" },
  { path: "/assistant", element: Assistant, permission: "assistant" },
  { path: "/analytics/restock-plan/list", element: AnalyticsRestockList, permission: "analytics" },
  { path: "/analytics/restock-plan", element: AnalyticsRestockPlanner, permission: "analytics" },
  { path: "/analytics/customer-buying-patterns/list", element: AnalyticsBuyingPatternsList, permission: "analytics" },
  { path: "/analytics/customer-buying-patterns", element: AnalyticsBuyingPatterns, permission: "analytics" },
  { path: "/analytics/turnover/list", element: AnalyticsTurnoverList, permission: "analytics" },
  { path: "/analytics/turnover", element: AnalyticsTurnover, permission: "analytics" },
  { path: "/analytics/demand-forecast/list", element: AnalyticsDemandForecastList, permission: "analytics" },
  { path: "/analytics/demand-forecast", element: AnalyticsDemandForecast, permission: "analytics" },
  { path: "/analytics/top-performers/list", element: AnalyticsTopPerformersList, permission: "analytics" },
  { path: "/analytics/top-performers", element: AnalyticsTopPerformers, permission: "analytics" },
  { path: "/analytics", element: Analytics, permission: "analytics" },
  { path: "/reports", element: Reports, permission: "analytics" },
  { path: "/reports/:reportType", element: Reports, permission: "analytics" },
];
